// NATIVE 
import { useEffect, useState } from 'react';


// INSTALLED 
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Grid, TextField } from '@mui/material';
import InputField from '../../../formFields/InputField';
import TextAreaField from '../../../formFields/TextAreaField';
import AutocompleteField from '../../../formFields/autocompleteField';
import CheckboxField from '../../../formFields/checkBoxField';
import DatePickerField from '../../../formFields/datePickerField';
import AutocompleteMultiple from '../../../formFields/AutocompleteMultiple';


// CUSTOM 





/**
 * CreateCargo component is responsible for rendering a form to create a new cargo.
 * It utilizes various form fields and checkboxes to gather necessary information.
 * 
 * @param {any} props - The properties passed to the component.
 * @returns {JSX.Element} The rendered component.
 * 
 * @component
 * 
 * @example
 * // Example usage:
 * <CreateCargo formField={formField} />
 * 
 * @typedef {Object} FormField
 * @property {Object} name - The name field configuration.
 * @property {Object} description - The description field configuration.
 * @property {Object} area - The area field configuration.
 * @property {Object} visita_domiciliaria - The visita_domiciliaria checkbox configuration.
 * @property {Object} prueba_psicotecnica - The prueba_psicotecnica checkbox configuration.
 * @property {Object} examen_alimentos - The examen_alimentos checkbox configuration.
 * @property {Object} examen_alturas - The examen_alturas checkbox configuration.
 * @property {Object} certificado_laboral - The certificado_laboral checkbox configuration.
 * @property {Object} certificado_estudios - The certificado_estudios checkbox configuration.
 * @property {Object} adres - The adres checkbox configuration.
 * @property {Object} antecedentes_judicial - The antecedentes_judicial checkbox configuration.
 * @property {Object} entrevista - The entrevista checkbox configuration.
 * @property {Object} sociodemografica - The sociodemografica checkbox configuration.
 * @property {Object} dme - The dme checkbox configuration.
 * @property {Object} sst - The sst checkbox configuration.
 * 
 * @typedef {Object} Props
 * @property {FormField} formField - The form field configurations.
 * 
 * @param {Props} props - The properties passed to the component.
 */
export const GeneracionTurnos = (props:any) => {


   // USE DISPATCH 
   const dispatch = useDispatch();

    // USE STATE 


    // USE SELECTOR  
    const { turnos_select_list }:any  = useSelector( (state:any) => state.turnos );
    const  { cargos_select }  = useSelector( (state:any) => state.cargos );
    const  { type_shifts_list_select, frecuency_shifts_list_select }  = useSelector( (state:any) => state.tipoTurnos );


    
    // FORM FIELDS 
    const { formField: {
        name,
        cargo,
        TipoTurno,
        turnos,
        fechaInicioTurno,
        frecuencia,
        autoGenerarse,
        domingosyFestivos
      }
    } = props;


            


  

   
    
    // CONST STYLE 
    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: 'wheat',
        padding: theme.spacing(8),
        textAlign: 'center'
    }));




  

    // Turno diurno
    // Horario: entre las 6:00 a.m. y las 9:00 p.m.
    // Duración máxima: la jornada diurna máxima es de 8 horas diarias y 48 horas semanales.
    // Remuneración: el trabajador recibe su salario normal sin recargos adicionales, ya que este turno no implica horas extra ni recargos nocturnos.



    // Turno nocturno
    // Horario: entre las 9:00 p.m. y las 6:00 a.m.
    // Duración máxima: la jornada laboral nocturna también tiene un límite de 8 horas diarias y 48 horas semanales.
    // Remuneración: el trabajo nocturno tiene un recargo adicional del 35% sobre el valor de la hora ordinaria debido a las condiciones de trabajo en horario nocturno.


    // Turno mixto
    // Horario: combina horas diurnas y nocturnas dentro de una misma jornada. Por ejemplo, una jornada de trabajo de 3:00 p.m. a 11:00 p.m.
    // Duración máxima: duración máxima de 8 horas diarias y 48 horas semanales.
    // Remuneración: se paga el salario ordinario por las horas trabajadas en el turno diurno y un recargo del 35% sobre el valor de la hora ordinaria por las horas trabajadas en horario nocturno (es decir, las horas entre las 9:00 p.m. y las 6:00 a.m.).
    

    // Turnos rotativos
    // Son aquellas jornadas de trabajo donde a pesar de que hay un horario, puede cambiar diaria o semanalmente siempre y cuando se le notifique al trabajador.

    // Dentro de los turnos rotativos se encuentra:

    // Rotativo 6X2 : este tipo de turnos consiste en que el empleado inicia la semana laboral con dos días de turno en la mañana, dos turnos en horas de la tarde y luego dos turnos de noche, obteniendo como resultado dos días de descanso continuo.

    // 5X2: aquí, son cinco días de trabajo consecutivo, donde la persona solo tendrá una hora de descanso, de modo que pueda contar con dos días libres.

    // 4X3: en estos turnos se superan las 10 horas de trabajo, por lo que el empleado completa la jornada máxima legal permitida en cuatro días, con derecho a descansar tres días.
    


//     🔹 Tipos de Turnos Rotativos Comunes en Colombia
// Turno 6x1 🏭

// 6 días de trabajo y 1 de descanso
// Puede rotar entre mañana, tarde y noche.
// Ejemplo:
// Semana 1: 6 días turno de mañana (6:00 AM - 2:00 PM)
// Semana 2: 6 días turno de tarde (2:00 PM - 10:00 PM)
// Semana 3: 6 días turno de noche (10:00 PM - 6:00 AM)
// Turno 4x2 🔄

// 4 días de trabajo y 2 de descanso
// Se usa en industrias como fábricas y hospitales.
// Ejemplo:
// 4 días en la mañana → 2 días libres
// 4 días en la tarde → 2 días libres
// 4 días en la noche → 2 días libres
// Turno 3x3 ⚡

// 3 días de trabajo y 3 de descanso
// Jornadas más largas (ejemplo: 12 horas por día).
// Común en sectores como minería y seguridad.
// Ejemplo:
// 3 días turno diurno (6:00 AM - 6:00 PM)
// 3 días de descanso
// 3 días turno nocturno (6:00 PM - 6:00 AM)
// Turno 5x2 🏢

// 5 días de trabajo y 2 de descanso
// Similar al horario de oficina pero con rotación.
// Ejemplo:
// Semana 1: 5 días turno de mañana
// Semana 2: 5 días turno de tarde
// Semana 3: 5 días turno de noche
// Turno 2x2x2 ⏳

// 2 días de mañana, 2 de tarde, 2 de noche y 2 de descanso
// Permite que los trabajadores roten equitativamente.
// Ejemplo:
// 2 días turno de mañana
// 2 días turno de tarde
// 2 días turno de noche
// 2 días de descanso




// Trabajo por turnos discontinuos
// En el turno discontinuo el colaborador cumple con su jornada máxima legal. Es decir, 8 horas diarias, pero dividido en dos turnos, esto es que la persona trabajará en la mañana y vuelve a retomar el horario en la noche.

// Los turnos de trabajo pueden aplicarse durante toda la semana, pero debe existir un acuerdo previo entre los directivos y el trabajador.

// Los turnos semidiscontinuos
// Los turnos pueden iniciar en la mañana, tarde o noche y los sábados. Cumpliendo con la jornada laboral exigida.


// Turnos continuos
// En la actualidad es el tipo más utilizad, pues aquí el empleado trabaja de forma consecutiva durante 8 horas. Claro, el empleador debe garantizar un espacio de descanso y/o alimentación.

// Este tipo de turnos es muy adoptado, ya que se considera que mejora la productividad y concentración del personal. Además, desestimula el absentismo laboral en la empresa.


  return (
    <div>
        
        <Grid container spacing={2} sx={{ padding: 2 }}>

           
            <Grid item xs={6}>
              <InputField 
                name={name.name}
                label={name.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
                           
              {
                  
                  ( cargos_select && Object.keys(cargos_select).length > 0 )
                      ?
                      <AutocompleteField 
                        options={cargos_select}
                        name={cargo.name}
                        label={cargo.label}
                        element={cargo.name}
                      />
                      :
                      <InputField 
                      disabled
                      error
                      name={'N/A'}
                      label={'Debes crear los cargos*'}
                      variant="outlined" 
                      fullWidth
                      />
              }
           </Grid>


            <Grid item xs={6}>
              {
                  
                  ( type_shifts_list_select && Object.keys(type_shifts_list_select).length > 0 )
                      ?
                      <AutocompleteField 
                        options={type_shifts_list_select}
                        name={TipoTurno.name}
                        label={TipoTurno.label}
                        element={TipoTurno.name}
                      />
                      :
                      <InputField 
                        disabled
                        error
                        name={'N/A'}
                        label={'Debes crear los tipos de turnos*'}
                        variant="outlined" 
                        fullWidth
                      />
              }
            </Grid>

            <Grid item xs={6}>

              {
                  
                  ( turnos_select_list && Object.keys(turnos_select_list).length > 0 )
                      ?
                        <AutocompleteMultiple 
                          options={turnos_select_list}
                          name={turnos.name}
                          label={turnos.label}
                          element={turnos.name}/>
                      :
                      <InputField 
                        disabled
                        error
                        name={'N/A'}
                        label={'Debes crear los horarios de turnos*'}
                        variant="outlined" 
                        fullWidth
                      />
              }
            
            </Grid>

            <Grid item xs={6}>

              {
                  
                  ( frecuency_shifts_list_select && Object.keys(frecuency_shifts_list_select).length > 0 )
                      ?
                      <AutocompleteField 
                        options={frecuency_shifts_list_select}
                        name={frecuencia.name}
                        label={frecuencia.label}
                        element={frecuencia.name}
                      />
                      :
                      <InputField 
                        disabled
                        error
                        name={'N/A'}
                        label={'Debes crear la frecuencia de turnos*'}
                        variant="outlined" 
                        fullWidth
                      />

              }
                
            </Grid>

            <Grid item xs={6} >
             <DatePickerField   
                    label={fechaInicioTurno.label} 
                    name={fechaInicioTurno.name}/>
             
            </Grid>

            {/* <Grid item xs={6} >
             <DatePickerField   
                    label={fechaInicioTurno.label} 
                    name={fechaInicioTurno.name}/>
             
            </Grid> */}

            


            <Grid item xs={3}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <CheckboxField  name={autoGenerarse.name} label={autoGenerarse.label}/>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <CheckboxField  name={domingosyFestivos.name} label={domingosyFestivos.label}/>
              </div>
            </Grid>


         </Grid>

        
         
       

        {/* <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid item xs={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={'visita_domiciliaria.name'} label={'visita_domiciliaria.label'}/>
                 </div>
            </Grid>
            <Grid item xs={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={'prueba_psicotecnica.name'} label={'prueba_psicotecnica.label'}/>
                </div>
            </Grid>
            <Grid item xs={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={'examen_alimentos.name'} label={'examen_alimentos.label'}/>
                </div>
            </Grid>
        </Grid> */}

    </div>
  )
}

